import { render, staticRenderFns } from "./cabinet-deals-primary-item.vue?vue&type=template&id=541e59c8&scoped=true&"
import script from "./cabinet-deals-primary-item.vue?vue&type=script&lang=js&"
export * from "./cabinet-deals-primary-item.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-deals-primary-item.vue?vue&type=style&index=0&id=541e59c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e59c8",
  null
  
)

export default component.exports